import React, { useState } from "react";
import {
  ShoppingCartOutlined,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar, Layout, Menu, Modal, Button, theme, message } from "antd";
import LOGO from "../../assets/fastest-logo.jpg.png";

import Order from "../orders/Orders";
import { logout } from "../../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import ScanPouchOrContainer from "../scan/ScanPouchOrContainers";
import AdminProfile from "../adminProfile/AdminProfile";

const { Sider, Content } = Layout;

const Navigation = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("1");
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
  const [logoutActive, setLogoutActive] = useState(false);
  const dispatch = useDispatch();

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const menuItems = [
    {
      key: "1",
      icon: <ShoppingCartOutlined className="!text-[16px]" />,
      label: "Scan Pouch/Containers",
      content: <ScanPouchOrContainer />,
    },
    {
      key: "2",
      icon: <ShoppingCartOutlined className="!text-[16px]" />,
      label: "Orders",
      content: <Order />,
    },
    {
      key: "3",
      icon: <UserOutlined className="!text-[16px]" />,
      label: "Users",
      content: <AdminProfile />,
    },
  ];

  const currentContent = menuItems.find(
    (item) => item.key === selectedMenuItem
  )?.content;

  const handleLogout = () => {
    // Dispatch the logout action to update Redux state
    dispatch(logout());

    console.log("User logged out and Redux state cleared");

    // Close the modal after logout
    setIsLogoutModalVisible(false);
    setLogoutActive(false);

    message.success("Logout Successful!");
  };

  const handleCancel = () => {
    setIsLogoutModalVisible(false); // Close the modal without logging out
    setLogoutActive(false); // Reset the logout button color
  };

  const showLogoutModal = () => {
    setIsLogoutModalVisible(true);
    setLogoutActive(true); // Change the logout button color when clicked
  };

  return (
    <Layout className="min-h-screen">
      <Sider
        collapsed={collapsed}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: "100vh",
        }}
      >
        {/* Logo Section */}
        <div
          style={{
            width: "100%",
            height: 50,
            color: "#FFFF",
            marginTop: "1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Avatar
            shape="square"
            src={LOGO}
            style={{ width: "300px", height: "50px" }}
          />
        </div>

        {/* Menu Items */}
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedMenuItem]}
          onClick={({ key }) => setSelectedMenuItem(key)}
          items={menuItems.map(({ key, icon, label }) => ({
            key,
            icon,
            label,
          }))}
          style={{ flex: 1 }} // Allow menu to grow and push logout to the bottom
        />

        {/* Logout Button Fixed to Bottom */}
        <div
          style={{
            padding: "1rem",
            textAlign: "center",
            position: "absolute",
            bottom: 0,
            width: "100%",
          }}
        >
          <Button
            type={logoutActive ? "primary" : "default"}
            icon={<LogoutOutlined />}
            className={`w-full ${logoutActive ? "bg-red-500" : ""}`}
            onClick={showLogoutModal}
          >
            Logout
          </Button>
        </div>
      </Sider>

      {/* Content Section */}
      <Layout>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: "calc(100vh - 48px)",
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          {currentContent}
        </Content>
      </Layout>

      {/* Logout Confirmation Modal */}
      <Modal
        title="Confirm Logout"
        visible={isLogoutModalVisible}
        onOk={handleLogout} // Logout when user clicks 'Yes'
        onCancel={handleCancel} // Close the modal when user clicks 'Cancel'
        okText="Yes"
        cancelText="Cancel"
      >
        <p>Are you sure you want to logout?</p>
      </Modal>
    </Layout>
  );
};

export default Navigation;
